export default __webpack_public_path__ + "static/media/Postcard-Pals-Logo.623489c3.png";